export default "__VITE_ASSET__C$iYfmku__"